import { TabLabel } from '@app/fallback-report/table-nav/table-nav.component';
import { FallbackReportExtension } from './fallback-report-extension';
import { factoryOpCoTabLabels } from './utilities';

/** this class configures the fallbackReport for use when the opCo is BGE */
export class BGEFallbackExtension extends FallbackReportExtension {
  readonly opCo = 'BGE';

  private BGEFields = [
    'PLACE_NAME',
    'CUSTOMERS_AFFECTED',
    'CUSTOMERS_SERVED',
    'CUSTOMERS_RESTORED',
    'PERCENT_AFFECTED',
    'NUMBER_OF_OUTAGES'
  ];

  private BGEHeaders = this.BGEFields
    .slice(1)
    .map(field => field.replace(/_/g, ' '));

  TableStyle = {
    Default: 0,
    Hidden: 1,
    BGEThousands: 2,
    BGERounded: 3,
    BGERoundedPercent: 4
  };

  private BGEStyles: { [datafield: string]: number } = {
    PLACE_NAME: this.TableStyle.Default,
    CUSTOMERS_AFFECTED: this.TableStyle.BGERounded,
    CUSTOMERS_SERVED: this.TableStyle.BGEThousands,
    CUSTOMERS_RESTORED: this.TableStyle.BGEThousands,
    PERCENT_AFFECTED: this.TableStyle.BGERoundedPercent,
    NUMBER_OF_OUTAGES: this.TableStyle.BGEThousands
  };

  DataEndpoint = {
    BGEByZipCode: '/bge/zip',
    BGEByCounty: '/bge/county'
  };

  DataFields = {
    BGEByZipCode: this.BGEFields,
    BGEByCounty: this.BGEFields
  };

  TableCelStyles = {
    BGEByZipCode: this.BGEStyles,
    BGEByCounty: this.BGEStyles
  };

  TableRowHeaders = {
    BGEByZipCode: ['ZIPCODE'].concat(this.BGEHeaders),
    BGEByCounty: ['COUNTY'].concat(this.BGEHeaders)
  };

  TableNavOverrides = {};

  TabLabels: Array<TabLabel>;

  TabOrder = [
    'BGEByCounty',
    'BGEByZipCode'
  ];

  constructor () {
    super();
    this.TabLabels = factoryOpCoTabLabels.bind(this)();
  }
}
